import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { ProdutoReembolso } from 'pages/financeiro/reembolso/consulta-reembolso/types';

export type QueryProdutoReembolso = {
    nrNota: number;
    dsSerie: number;
    cdLoja: number;
};
export function useQueryProdutoReembolso({ nrNota, dsSerie, cdLoja }: QueryProdutoReembolso) {
    const requestListagem = useRequestListagem();
    const { sort, page, limit } = useListagemContext();

    const requestOptions: RequestOptionsType = {
        url: '/financeiro/apuracaolojapromocaoprodutovendawrapper/nrmovimentacao',
        sort: sort.length ? sort : [{ property: 'idProduto', direction: 'DESC' }],
        filter: [
            { property: 'cdLoja', value: cdLoja, operator: 'eq' },
            { property: 'nrNota', value: nrNota, operator: 'eq' },
            { property: 'dsSerie', value: dsSerie, operator: 'eq' },
        ],
        nested: true,
        page,
        limit,
    };

    return useQuery<RequestListagem<ProdutoReembolso[]>>(['queryProduto', requestOptions], () =>
        requestListagem(requestOptions).then((res) => res.data),
    );
}
